<template>
  <div class="about w1400">
  	<div class="about-title font20">
  		当前位置：关于平台 > 关于平台
  	</div>
  	<div class="about-cont" >
         <h1>{{aboutText.ty002}}</h1>
         <div id="newsAbout" ></div>
        <img src="../../assets/skeleton.png" alt="" v-if="!aboutText.ty005">
  	</div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        aboutText:{}
      }
    },
    mounted() {
      this.getAbout()
    },
    methods:{
      getAbout(){
        this.$axios.post('/api/news/getById',{
          quoteid:57
        }).then(res=>{
          this.aboutText =  res.data.data;
          document.querySelector('#newsAbout').innerHTML = res.data.data.ty005;
          console.log(res)
        })
      }
    }
  }
</script>

<style scoped>
  .about{
    min-height: 80rem;
  }
  .about-title{
    box-sizing: border-box;
    height: 7rem;
    line-height: 7rem;
    padding-left: 2.7rem;
    background-color: #F6F5F5;
  }
  .about-cont{
    width: 85%;
    margin: 0 auto;
  }
  .about-cont > img{
    display: block;
    max-width: 80%;
    margin: 10px auto;
  }
  #newsAbout{
    text-indent: 4rem;
    font-size: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/about.vue